import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿El material es físico o digital?',
    a: 'Es 100% digital. Inmediatamente después de tu compra, vas a recibir un correo electrónico con el acceso para descargar la guía y todos los bonos en formato PDF. Podés leerlo en tu celular, tablet, computadora o imprimirlo.'
  }, {
    q: '¿Sirve si también tengo colesterol alto o diabetes?',
    a: 'Sí, la alimentación propuesta en la guía está basada en comida real, antiinflamatoria y de bajo índice glucémico, lo cual es excelente también para acompañar el tratamiento del colesterol y la resistencia a la insulina.'
  }, {
    q: '¿Tengo que comprar ingredientes caros o raros?',
    a: 'Para nada. Todas las recetas están pensadas con ingredientes que conseguís en cualquier supermercado o verdulería de barrio. La idea es simplificarte la vida, no complicarla.'
  }, {
    q: '¿Cuáles son los medios de pago?',
    a: 'Podés pagar con tarjeta de crédito, débito o dinero en cuenta a través de MercadoPago. El pago es 100% seguro y procesado por la plataforma.'
  }];
  return <section className="py-20 bg-white" data-id="element-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <h2 className="text-3xl font-bold text-stone-900 mb-4" data-id="element-23">
            Preguntas Frecuentes
          </h2>
          <p className="text-stone-600" data-id="element-24">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-26" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-stone-200 rounded-2xl overflow-hidden bg-stone-50" data-id="element-27">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-28">
        <span className="font-bold text-stone-900 pr-4" data-id="element-29">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-brand-600 transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-30" />
      </button>
      <AnimatePresence data-id="element-31">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-32">
            <div className="px-6 pb-5 text-stone-600 leading-relaxed" data-id="element-33">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}